import { baseClient } from '../_api';

export const requestPasswordReset = emailOrPhone => baseClient.post('/request_password_reset/', { emailOrPhone });
export const confirmPasswordReset = (newPassword, token, finishAllSession) =>
  baseClient.post('/reset_password/', { newPassword, token, finishAllSession });
